// Розпізнавання колонок файлу СПИСКУ СТУДЕНТІВ (окремий імпорт без балів).
// Зазвичай це список усього факультету, а не лише мешканців гуртожитку, тому
// обов'язковий лише ПІБ; кімната, група, курс, стать, віддаленість і пільга -
// необов'язкові й зіставляються за заголовком (або вручну на сторінці).

export const STUDENT_COLUMN_PATTERNS = {
  pib: /П\.?І\.?Б|прізвищ/i,
  room: /кімнат/i,
  group: /груп/i,
  course: /курс/i,
  gender: /стать/i,
  zone: /віддален|зона/i,
  privilege: /пільг/i,
};

export const STUDENT_COLUMN_LABELS = {
  pib: "ПІБ",
  room: "Кімната",
  group: "Група",
  course: "Курс",
  gender: "Стать",
  zone: "Віддаленість (1–3)",
  privilege: "Пільга (1–3)",
};

export const STUDENT_COLUMN_KEYS = Object.keys(STUDENT_COLUMN_PATTERNS);

function cellText(cell) {
  return cell === null || cell === undefined ? "" : String(cell).trim();
}

// Індекси колонок за заголовками одного рядка: кожен ключ - перший збіг,
// кожна колонка належить не більше ніж одному ключу.
export function detectStudentColumns(headerRow) {
  const indices = Object.fromEntries(STUDENT_COLUMN_KEYS.map((k) => [k, null]));
  (headerRow || []).forEach((cell, index) => {
    const text = cellText(cell);
    if (!text) return;
    const key = STUDENT_COLUMN_KEYS.find((k) => indices[k] === null && STUDENT_COLUMN_PATTERNS[k].test(text));
    if (key) indices[key] = index;
  });
  return indices;
}

// Перший із перших maxScan рядків, де знайдено колонку ПІБ.
export function findStudentHeaderRow(rows, maxScan = 20) {
  const limit = Math.min(rows.length, maxScan);
  for (let i = 0; i < limit; i += 1) {
    const indices = detectStudentColumns(rows[i]);
    if (indices.pib !== null) {
      const headerEntries = (rows[i] || [])
        .map((cell, index) => ({ index, text: cellText(cell) }))
        .filter((e) => e.text);
      return { rowIndex: i, indices, headerEntries };
    }
  }
  return null;
}

const cell = (v) => {
  if (v === undefined || v === null) return null;
  return typeof v === "number" || typeof v === "string" ? v : String(v);
};

// Рядки для POST /api/import/rating/preview (mode=students): лише розпізнані
// значення комірок; порожні рядки (без ПІБ і без жодного значення) відкидаються.
export function buildStudentUploadRows(dataRows, indices) {
  const pick = (row, key) => (indices[key] === null || indices[key] === undefined ? null : cell(row[indices[key]]));
  return (dataRows || [])
    .filter((row) => row.some((c) => c !== null && c !== undefined && String(c).trim() !== ""))
    .map((row, i) => {
      const pib = pick(row, "pib");
      return {
        rowNumber: i + 1,
        pib: pib === null ? "" : String(pib).trim(),
        room: pick(row, "room"),
        group: (() => {
          const g = pick(row, "group");
          return g === null ? null : String(g);
        })(),
        course: pick(row, "course"),
        gender: (() => {
          const g = pick(row, "gender");
          return g === null ? null : String(g);
        })(),
        zone: pick(row, "zone"),
        privilege: pick(row, "privilege"),
      };
    });
}
